export default {
  me: {},
  loggedUser: {},
  organization: {}
}
